// extracted by mini-css-extract-plugin
export default {"custom-products-slider":"CustomSlider_custom-products-slider__0DXp6","active-custom-slider":"CustomSlider_active-custom-slider__5KeQo"};